import React from "react";
import TextTheme from "components/General/Text/TextTheme";

const TextArea = (props) => (
  <div className="form-group " style={{ width: "100%" }}>
    {props.title ? (
      <TextTheme
        message={props.title}
        className="text_medium text_dark_blue text_semi_bold"
      />
    ) : null}
    <textarea
      className={
        props.textClassName === "none"
          ? "form-control custom_text_area"
          : "form-control textarea-main custom_text_area"
      }
      name={props.name}
      rows={props.rows}
      cols={props.cols}
      value={props.value}
      onChange={props.handleChange}
      placeholder={props.placeholder}
    />
  </div>
);

export default TextArea;
